import { useMemo } from "react";
import "./index.css";

const DOWNLOAD_BASE = "https://pub-028cd89e378d4b97aa02d57d87a89336.r2.dev";

const TARGETS = [
  { os: "macOS", arch: "Apple Silicon", target: "darwin-arm64" },
  { os: "Linux", arch: "ARM64", target: "linux-arm64" },
  { os: "Linux", arch: "x86_64", target: "linux-x86_64" },
] as const;

function downloadUrl(target: string): string {
  return `${DOWNLOAD_BASE}/quad-code-${target}`;
}

function detectPlatform(): string | null {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("mac")) return "darwin-arm64";
  if (ua.includes("linux")) return "linux-x86_64";
  return null;
}

export default function App() {
  const detected = useMemo(detectPlatform, []);

  return (
    <div className="terminal">
      <div className="scanlines" aria-hidden="true" />
      <header className="terminal-bar">
        <div className="terminal-dots">
          <span className="dot" />
          <span className="dot" />
          <span className="dot" />
        </div>
        <span className="terminal-title">quad-code — zsh</span>
        <div className="terminal-dots invisible" aria-hidden="true">
          <span className="dot" />
          <span className="dot" />
          <span className="dot" />
        </div>
      </header>

      <div className="terminal-body">
        <h1 className="brand">quad-code</h1>
        <p className="tagline">
          terminal ui for <span className="highlight">qualia</span>, the
          research agent
        </p>

        <div className="targets">
          {TARGETS.map((t) => {
            const isDetected = t.target === detected;
            return (
              <a
                key={t.target}
                href={downloadUrl(t.target)}
                className={`target-row${isDetected ? " recommended" : ""}`}
              >
                <span className="target-file">quad-code-{t.target}</span>
                <span className="target-platform">
                  {t.os} · {t.arch}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}
